import global from "@/prototype/global.js";

const d3 = global.d3;

const points_distance = (P1, P2) => d3.geoDistanceMeters(P1.EN, P2.EN);
const points_bearing = (P1, P2, C) => {
    return Math.atan2(P1.Y - C.Y, P1.X - C.X) - Math.atan2(P2.Y - C.Y, P2.X - C.X);
};
const points_angle = (P1, P2) => Math.atan2(P2.Y - P1.Y, P2.X - P1.X);

const minN = (P1, P2) => Math.min(P1.N, P2.N);
const maxN = (P1, P2) => Math.max(P1.N, P2.N);
const minE = (P1, P2) => Math.min(P1.E, P2.E);
const maxE = (P1, P2) => Math.max(P1.E, P2.E);

const minX = (P1, P2) => Math.min(P1.X, P2.X);
const maxX = (P1, P2) => Math.max(P1.X, P2.X);
const minY = (P1, P2) => Math.min(P1.Y, P2.Y);
const maxY = (P1, P2) => Math.max(P1.Y, P2.Y);

const dN = (P1, P2) => maxN(P1, P2) - minN(P1, P2); // delta latitude
const dE = (P1, P2) => maxE(P1, P2) - minE(P1, P2); // delta longitude

// compute average angle, ref: https://en.wikipedia.org/wiki/Mean_of_circular_quantities
const aT = (T1, T2) => Math.atan2((Math.sin(T1) + Math.sin(T2)) / 2, (Math.cos(T1) + Math.cos(T2)) / 2); 

const distance_to_string = (d, precision) => {
    d = parseFloat(d.toPrecision(precision));
    if (d < 1000) {
        return `${d} m`;
    } else {
        return `${d / 1000} km`;
    }
};


export {points_distance, points_bearing, points_angle, minN, maxN, minE, maxE, minX, maxX, minY, maxY, dN, dE, aT, distance_to_string};